export default __webpack_public_path__ + "static/media/11.0ab66e64.svg";